import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';

import { boardService, templateMngService } from '../../services';
import { alertActions } from '../../modules/alert';
import { utilHelper } from '../../helpers';
import CustomizedDialog from '../Dialog/CustomizedDialog';
import './opbpreview.css';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

class OpbPreview extends Component {
    mounted = false;
    promotionIdx = -1;
    marketingIdx = -1;
    bottomIdx = -1;

    constructor(props) {
        super(props);

        this.state = {
            opbInfo: null,
            backgroundImage: null,

            promotionBuffer: "",
            promotionContentKindCode: "",
            marketingBuffer: "",
            marketingContentKindCode: "",
            bottomBuffer: "",
            bottomContentKindCode: "",

            isMobile: false,
        };
    }

    resize() {
        let isMobile = (window.innerWidth < 992);
        if (isMobile !== this.state.isMobile) {
            this.setState({
                isMobile: isMobile,
            });
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener("resize", this.resize.bind(this));
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.open !== this.props.open) {
            this.mounted = !this.mounted;
            this.promotionIdx = -1;
            this.marketingIdx = -1;
            this.bottomIdx = -1;
            this.setState({
                opbInfo: this.props.opbInfo,
                backgroundImage: null,
                promotionBuffer: "",
                promotionContentKindCode: "",
                marketingBuffer: "",
                marketingContentKindCode: "",
                bottomBuffer: "",
                bottomContentKindCode: "",
            });
        }

        if (this.mounted && this.state.opbInfo && !this.state.backgroundImage) {
            // 배경 다운로드
            this.setBackgroundImage();
        }
        else if (this.mounted && prevState.backgroundImage !== this.state.backgroundImage && this.state.backgroundImage) {
            // 상단 영상 다운로드
            if (this.state.opbInfo.promotionList && this.state.opbInfo.promotionList.length > 0) {
                this.setDownloadContent("promotion");
            }
            // 중앙 영상 다운로드
            if (this.state.opbInfo.marketingList && this.state.opbInfo.marketingList.length > 0) {
                this.setDownloadContent("marketing");
            }
            // 하단 영상 다운로드
            if (this.state.opbInfo.bottomList && this.state.opbInfo.bottomList.length > 0) {
                this.setDownloadContent("bottom");
            }

        }
        else if (this.mounted && this.state.backgroundImage) {
            if (this.state.promotionBuffer && prevState.promotionBuffer !== this.state.promotionBuffer) {
                // 상단 영상 재생
                this.showPromotionContent();
            }
            if (this.state.marketingBuffer && prevState.marketingBuffer !== this.state.marketingBuffer) {
                // 중앙 영상 재생
                this.showMarketingContent();
            }
            if (this.state.bottomBuffer && prevState.bottomBuffer !== this.state.bottomBuffer) {
                // 하단 영상 재생
                this.showBottomContent();
            }
        }
    }

    setBackgroundImage = () => {
        const { opbInfo } = this.props;
        templateMngService.downloadFile('theme', opbInfo.themeID)
            .then(response => {
                if (this.mounted && response.data) {
                    this.setState({
                        backgroundImage: "url(data:image/jpeg;base64," + Buffer.from(response.data, 'binary').toString('base64') + ")",
                    });
                }
            })
            .catch(this.handleErrors);
    };

    setDownloadContent = (widgetKind) => {
        if (this.mounted) {
            const { promotionList, marketingList, bottomList } = this.state.opbInfo;
            if (widgetKind === 'promotion' && promotionList.length > 0) {
                this.promotionIdx = (this.promotionIdx + 1) % promotionList.length;
                this.downloadContent("promotion", promotionList, this.promotionIdx);
            }
            else if (widgetKind === 'marketing' && marketingList.length > 0) {
                this.marketingIdx = (this.marketingIdx + 1) % marketingList.length;
                this.downloadContent("marketing", marketingList, this.marketingIdx);
            }
            else if (widgetKind === 'bottom' && bottomList.length > 0) {
                this.bottomIdx = (this.bottomIdx + 1) % bottomList.length;
                this.downloadContent("bottom", bottomList, this.bottomIdx);
            }
        }
    };


    downloadContent = async (widgetKind, contentsList, Idx) => {
        let targetContentsList = [...contentsList];
        const content = targetContentsList[Idx];

        let state = { list: "", buffer: "", contentKindCode: "", showTime: 0 };
        if (widgetKind === "promotion") state = { list: "promotionList", buffer: "promotionBuffer", contentKindCode: "promotionContentKindCode" };
        else if (widgetKind === "marketing") state = { list: "marketingList", buffer: "marketingBuffer", contentKindCode: "marketingContentKindCode" };
        else if (widgetKind === "bottom") state = { list: "bottomList", buffer: "bottomBuffer", contentKindCode: "bottomContentKindCode" };

        if (!content.buffer) {
            boardService.downloadFile("common", content.boardID, content.boardfileID)
                .then(response => {
                    const buffer = response.data && Buffer.from(response.data, 'binary').toString('base64');
                    targetContentsList[Idx].buffer = buffer;
                    if (this.mounted) {
                        this.setState({
                            opbInfo: {
                                ...this.state.opbInfo,
                                [state.list]: targetContentsList,
                            },
                            [state.buffer]: buffer,
                            [state.contentKindCode]: content.contentKindCode
                        });
                    }
                })
                .catch(this.handleErrors);
        }
        else {
            this.setState({
                [state.buffer]: content.buffer,
                [state.contentKindCode]: content.contentKindCode
            });
        }
    };

    checkEnabledContentShow = (targetContent) => {
        //스케쥴 설정 선택이 없으면 무조건 보여준다.
        if (!targetContent.enabledDate && !targetContent.enabledTime && !targetContent.enabledDow)
            return true;
        else {
            const nowDate = new Date();
            let isEnabledDate = true;
            let isEnabledDow = true;
            let isEnabledTime = true;

            if (targetContent.enabledDate) {
                const startDate = utilHelper.dateFromMysqlDateTime(targetContent.startDate);
                const endDate = utilHelper.dateFromMysqlDateTime(targetContent.endDate);
                isEnabledDate = nowDate >= startDate && nowDate <= endDate ? true : false;
            }

            if (targetContent.enabledDow) {
                const today = nowDate.getDay();
                const enabledDays = targetContent.dowMask ? targetContent.dowMask.split("") : ['0', '0', '0', '0', '0', '0', '0'];
                isEnabledDow = enabledDays[today] === '1' ? true : false;
            }

            if (targetContent.enabledTime) {
                const startTime = new Date(utilHelper.getStringDate(nowDate) + " " + targetContent.startTime);
                const endTime = new Date(utilHelper.getStringDate(nowDate) + " " + targetContent.endTime);
                isEnabledTime = nowDate >= startTime && nowDate <= endTime ? true : false;
            }

            return (isEnabledDate && isEnabledDow && isEnabledTime) ? true : false;
        }
    };

    showContent = (widgetKind, showTime) => {
        showTime = showTime || 10000;
        const elements = document.getElementsByClassName(widgetKind);
        const targetChild = elements[0].firstChild;

        if (targetChild && targetChild.nodeName === 'VIDEO') {
            targetChild.load();
            targetChild.currentTime = 0;
            targetChild.play();
            targetChild.onended = () => {
                this.setDownloadContent(widgetKind);
            };
        } else {
            setTimeout(() => {
                this.setDownloadContent(widgetKind);
            }, showTime);
        }
    };

    showPromotionContent = async () => {
        if (this.mounted) {
            console.log('OpbPreview::showPromotionContent is called.');
            const { promotionList } = this.state.opbInfo;

            if (promotionList && promotionList.length > 0) {
                const content = promotionList[this.promotionIdx];
                if (this.checkEnabledContentShow(content)) {
                    this.showContent('promotion', content.showTime);
                }
                else {
                    this.promotionIdx = (this.promotionIdx + 1) % promotionList.length;
                    this.downloadContent("promotion", promotionList, this.promotionIdx);
                }
            }
        }
    };

    showMarketingContent = async () => {
        if (this.mounted) {
            console.log('OpbPreview::showMarketingContent is called.');
            const { marketingList } = this.state.opbInfo;

            if (marketingList && marketingList.length > 0) {
                const content = marketingList[this.marketingIdx];
                if (this.checkEnabledContentShow(content)) {
                    this.showContent('marketing', content.showTime);
                }
                else {
                    this.marketingIdx = (this.marketingIdx + 1) % marketingList.length;
                    this.downloadContent("marketing", marketingList, this.marketingIdx);
                }
            }
        }
    };

    showBottomContent = async () => {
        if (this.mounted) {
            console.log('OpbPreview::showBottomContent is called.');
            const { bottomList } = this.state.opbInfo;

            if (bottomList && bottomList.length > 0) {
                const content = bottomList[this.bottomIdx];
                if (this.checkEnabledContentShow(content)) {
                    this.showContent('bottom', content.showTime);
                }
                else {
                    this.bottomIdx = (this.bottomIdx + 1) % bottomList.length;
                    this.downloadContent("bottom", bottomList, this.bottomIdx);
                }
            }
        }
    };

    getContentsComp = (kind, buffer, contentKindCode) => {
        return (
            <div className={`${kind}`} id={`${kind}`} >
                {contentKindCode === "CK003"
                    ? <video className={`preview-video`} loop={false} src={"data:video/mp4;base64," + buffer} style={{ objectFit: "fill" }} muted={true} />
                    : <img className={`preview-image`} src={"data:image/jpeg;base64," + buffer} alt="이미지" />
                }
            </div>
        );
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleClose = () => {
        this.props.handleClosePreview();
    };

    render() {
        const { opbInfo, backgroundImage,
            promotionBuffer, promotionContentKindCode,
            marketingBuffer, marketingContentKindCode,
            bottomBuffer, bottomContentKindCode, isMobile } = this.state;

        return (
            <>
                <CustomizedDialog isFullScreen={isMobile} open={this.props.open} handleClose={this.handleClose}>
                    <div className="preivew-dialog-content">
                        <div className="preview-pannel" style={{ backgroundImage: backgroundImage, backgroundRepeat: "no-repeat", backgroundSize: "100% 100%" }}>
                            {!backgroundImage
                                ?
                                <>
                                    <div className="h200"></div>
                                    <Loader type="Rings" color="#00BFFF" height={'50%'} width={'50%'} />
                                </>
                                :
                                <>
                                    <div className={`clock-widget clock-style-${opbInfo && opbInfo.templateID}`}>
                                    </div>
                                    <div id='promotion-widget' className={`promotion-widget promotion-style-${opbInfo && opbInfo.templateID}`}>
                                        {opbInfo.promotionList && opbInfo.promotionList.length > 0 && !promotionBuffer &&
                                            <Loader type="Rings" color="#00BFFF" height={'50%'} width={'50%'} />
                                        }
                                        {opbInfo.promotionList && opbInfo.promotionList.length > 0 && promotionBuffer &&
                                            this.getContentsComp('promotion', promotionBuffer, promotionContentKindCode)
                                        }
                                    </div>
                                    <div className={`goingfloors-widget goingfloors-style-${opbInfo && opbInfo.templateID}`}>
                                    </div>
                                    <div id='marketing-widget' className={`marketing-widget marketing-style-${opbInfo && opbInfo.templateID}`}>
                                        {opbInfo.marketingList && opbInfo.marketingList.length > 0 && !marketingBuffer &&
                                            <Loader type="Rings" color="#00BFFF" height={'50%'} width={'50%'} />
                                        }
                                        {opbInfo.marketingList && opbInfo.marketingList.length > 0 && marketingBuffer &&
                                            this.getContentsComp('marketing', marketingBuffer, marketingContentKindCode)
                                        }
                                    </div>
                                    <div className={`news-widget news-style-${opbInfo && opbInfo.templateID}`}>
                                    </div>
                                    <div id='bottom-widget' className={`bottom-widget bottom-style-${opbInfo && opbInfo.templateID}`}>
                                        {opbInfo.bottomList && opbInfo.bottomList.length > 0 && !bottomBuffer &&
                                            <Loader type="Rings" color="#00BFFF" height={'50%'} width={'50%'} />
                                        }
                                        {opbInfo.bottomList && opbInfo.bottomList.length > 0 && bottomBuffer &&
                                            this.getContentsComp('bottom', bottomBuffer, bottomContentKindCode)
                                        }
                                    </div>

                                </>
                            }
                        </div>
                        <div className="preview-bottom-button-wrapper">
                            <button className="button w100-button" variant="contained" color="primary" onClick={this.handleClose}>닫기</button>
                        </div>
                    </div>
                </CustomizedDialog>
            </>
        );
    }
}

function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(OpbPreview);